import {
  Avatar,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  makeStyles,
  Theme,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { Person } from '@material-ui/icons';
import { useGenericStyles } from 'common/genericStyles';
import React from 'react';

interface FuncaoCardProps {
  selected?: boolean;
  onClick: () => void;
  title: string;
  description: string;
  dataTestId?: string;
}

const useStyles = (selected?: boolean) =>
  makeStyles((theme: Theme) => ({
    root: {
      overflow: 'hidden',
      border: `1px solid ${selected ? theme.palette.primary.main : 'rgba(0, 0, 0, 0.12)'}`,
    },
  }));

export const FuncaoCard: React.FC<FuncaoCardProps> = (props) => {
  const selectedStyle = useStyles(true)();
  const defaultStyle = useStyles()();
  const genericClasses = useGenericStyles();

  return (
    <Card variant="outlined" classes={{ root: props.selected ? selectedStyle.root : defaultStyle.root }}>
      <CardActionArea onClick={props.onClick} data-testid={props.dataTestId}>
        <CardContent>
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs={2}>
              <Avatar>
                <Person />
              </Avatar>
            </Grid>
            <Grid item xs={10}>
              <Grid container alignItems="flex-start">
                <Grid item xs={12}>
                  <Typography variant="body1">{props.title}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Tooltip title={props.description} aria-label={props.description}>
                    <Typography variant="body1" color="textSecondary" className={genericClasses.wrapTxt}>
                      {props.description}
                    </Typography>
                  </Tooltip>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};
